<style>
    svg {
        position: absolute;
        top: 400px;
        right: 23px;
        width: 113.28px;
        height: 35.69px;
    }

    .cls-1 {
        fill: #FFF;
        stroke: #FFF;
    }
</style>

<svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 386.78 50">
    <g id="quick-nav">
        <g>
            <g class="cls-2">
                <path class="cls-1" d="M371.17,21.82l-2.02-2.02-2.17,2.17-2.75-2.75,2.17-2.17-2.02-2.02,8.16-1.37-1.37,8.16Zm-2.17,9.32l-1.08,1.08-14.45-14.45,1.08-1.08,14.45,14.45Zm-5.56,3.32l-7.8,7.73-1.08-1.08,7.8-7.8,1.08,1.16Zm-12.21,3.32l7.8-7.8,2.24,2.24-7.8,7.8-2.24-2.24Zm-2.17-2.17l7.73-7.88,1.08,1.16-7.73,7.8-1.08-1.08Zm-4.48-4.48l7.73-7.8,3.32,3.32-7.73,7.8-3.32-3.32Zm31.07-24.49l-6.65-6.65-32.23,32.23,6.65,6.65c1.26-1.06,3.13-.98,4.3,.18s1.25,3.03,.18,4.3l6.65,6.65,32.23-32.23-6.65-6.65c-1.26,1.06-3.13,.98-4.3-.18s-1.25-3.03-.18-4.3"/>
            </g>
            <g class="cls-2">
                <path class="cls-1" d="M241.54,42.5c16.26,0,25.09-13.47,25.09-25.09v-1.18c1.73-1.25,3.23-2.79,4.41-4.56-1.61,.72-3.32,1.19-5.08,1.4,1.85-1.09,3.23-2.82,3.9-4.86-1.73,1.02-3.62,1.75-5.59,2.13-2.72-2.95-7.09-3.7-10.64-1.81-3.55,1.89-5.37,5.92-4.45,9.83-7.09-.36-13.69-3.7-18.17-9.2-2.34,4.03-1.15,9.18,2.72,11.77-1.39-.05-2.76-.42-3.97-1.1v.15c.02,4.18,2.97,7.77,7.06,8.61-.77,.2-1.56,.3-2.35,.29l-1.69-.15c1.16,3.59,4.47,6.04,8.24,6.11-3.1,2.45-6.93,3.8-10.89,3.83l-2.13-.15c4.04,2.6,8.74,3.98,13.54,3.97"/>
            </g>
            <g class="cls-2">
                <g>
                    <path class="cls-1" d="M26,25.39l-13.58,7.83h-.58c-.2-.1-.32-.3-.32-.52v-15.65c-.01-.22,.1-.43,.29-.54,.19-.11,.43-.1,.61,.02l13.58,7.83c.19,.1,.32,.3,.32,.52s-.12,.42-.32,.52m8.6-9.44v-.58c0-3.18-2.58-5.76-5.76-5.76H5.76c-3.18,0-5.76,2.58-5.76,5.76v19.28c0,3.18,2.58,5.76,5.76,5.76H28.72c3.17,0,5.75-2.53,5.82-5.69l.06-18.76Z"/>
                    <polygon class="cls-1" points="36.48 33.34 46.12 37.1 46.12 12.65 36.48 16.4 36.48 33.34"/>
                    <rect class="cls-1" x="48.06" y="12.65" width="1.94" height="24.47"/>
                </g>
            </g>
            <g>
                <path class="cls-1" d="M142.29,7.63c-.3-.17-.67-.17-.97,0l-16.76,9.68c-.1,.06-.17,.16-.25,.25h-6.15c-1.51,0-2.75,1.26-2.75,2.8v8.41c0,1.54,1.24,2.8,2.75,2.8h6.53l16.59,10.78c.16,.1,.34,.16,.53,.16,.16,0,.32-.04,.46-.12,.31-.17,.51-.5,.51-.85V8.47c0-.35-.19-.67-.48-.84Z"/>
                <line class="cls-1" x1="148.17" y1="31.02" x2="157.64" y2="36.48"/>
                <line class="cls-1" x1="148.17" y1="18.98" x2="157.64" y2="13.52"/>
            </g>
        </g>
    </g>
</svg>